import React from 'react';
import AddAdvertisement from './add-advertisement';

// This component reuses the AddAdvertisement component in edit mode
const EditAdvertisement = () => {
  return <AddAdvertisement />;
};

export default EditAdvertisement;

